export const formatAmount = (
  language = "en",
  value = 0,
  currency = "USD",
  noValue = "No amount"
) => {
  if (value) {
    const currencyCode = currency == "" ? "USD" : currency;
    return value.toLocaleString(language, {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 0,
    });
  }
  return noValue;
};

export const formatCompactAmount = (
  language = "en",
  value = 0,
  currency = "USD",
  noValue = "No amount"
) => {
  if (value) {
    const currencyCode = currency == "" ? "USD" : currency;
    return value.toLocaleString(language, {
      style: "currency",
      currency: currencyCode,
      notation: "compact",
      compactDisplay: "short",
      maximumFractionDigits: 0,
    });
  }
  return noValue;
};

export function formatNumber(value: number | string): string {
  const num = Number(value);

  // Handle invalid values
  if (isNaN(num)) return "0";

  const abs = Math.abs(num);

  const format = (n: number, suffix: string) => `${n.toFixed(1).replace(/\.0$/, "")}${suffix}`;

  if (abs >= 1_000_000_000) {
    return format(num / 1_000_000_000, "B");
  }

  if (abs >= 1_000_000) {
    return format(num / 1_000_000, "M");
  }

  if (abs >= 1_000) {
    return format(num / 1_000, "K");
  }

  if (abs >= 1) {
    return format(num, "");
  }

  return num.toFixed(2).replace(/\.00$/, "");
}
